import { start } from "../lib/Confetti.ts";
import { isSameDay, isToday } from "../lib/DateUtils.ts";
import * as Html from "../util/Html.ts";
import * as i18n from "../i18n.ts";

export {initDom,destroyDom}
Html.registerWidget('widget/countdown',{initDom:initDom,destroyDom:destroyDom})

function delta(d :Date,ref = new Date()){
  var delta = Math.floor((d.getTime() - ref.getTime())/1000),
    deltaD :number,deltaH :number,deltaM :number,deltaS :number;
  deltaS = delta%60;
  delta -= deltaS;
  deltaM  = (delta/60)%60;
  delta -= 60*deltaM;
  deltaH = (delta/3600)%24;
  delta -= (3600)*deltaH;
  deltaD = (delta/3600/24);


  return {deltaS,deltaM,deltaH,deltaD};
}

function initDom(domNode: HTMLElement){
  const chronoEnd = domNode.getAttribute('data-chrono-end');
  if(!chronoEnd) return;

  const date = new Date(chronoEnd);
  const nodes = domNode.querySelectorAll('h1');
  const units = domNode.querySelectorAll('.sub4')

  function refresh(isFirst ?:boolean){
    const
      now = new Date(),
      {deltaS,deltaM,deltaH,deltaD} = delta(date,now);

    //if chrono has ended
    if(deltaD>999){
      domNode.style.display='none'
    }else if(now>=date && !isSameDay(now,date)){
      domNode.style.display='none'
    }else if(now>=date){
      //we stop the refreshing
      nodes[0].textContent = '0';
      units[0].textContent = i18n.get('timeunit.day');
      nodes[1].textContent = '0';
      units[1].textContent = i18n.get('timeunit.hour');
      nodes[2].textContent = '0';
      units[2].textContent = i18n.get('timeunit.minute');
      nodes[3].textContent = '0';
      units[3].textContent = i18n.get('timeunit.second');

      const intervalId = domNode.getAttribute('data-interval');
      if(intervalId) {
        clearInterval(parseInt(intervalId));
      }
      if(isToday(date)){
        const metaId = Html.getDomMetaId(domNode);
        if(!disableConfettiFor || disableConfettiFor !== metaId){
          start(1000)
        }
      }
    } else{
      nodes[0].textContent = ''+deltaD;
      nodes[1].textContent = ''+deltaH;
      nodes[2].textContent = ''+deltaM;
      nodes[3].textContent = ''+deltaS;
      units[0].textContent = i18n.get(deltaD>1?'timeunit.days':'timeunit.day');
      units[1].textContent = i18n.get(deltaH>1?'timeunit.hours':'timeunit.hour');
      units[2].textContent = i18n.get(deltaM>1?'timeunit.minutes':'timeunit.minute');
      units[3].textContent = i18n.get(deltaS>1?'timeunit.seconds':'timeunit.second');

    }
  }

  const intervalId = setInterval(refresh,1000);
  domNode.setAttribute('data-interval', intervalId.toString());

  refresh(true);
}

let disableConfettiFor : string | undefined;
function destroyDom(domNode: HTMLElement){
  //if we refresh confetti will reappear
  disableConfettiFor = Html.getDomMetaId(domNode);
  setTimeout(()=>disableConfettiFor = undefined,5000);

  const intervalId = domNode.getAttribute('data-interval');
  if(intervalId) {
    clearInterval(parseInt(intervalId));
    domNode.removeAttribute('data-interval');
  }
}